import React, { useEffect, useState } from 'react';
import '../style.css';
import InputMask from 'react-input-mask';

interface PhoneInputProps {
  name?: string;
  placeholder: string;
  value?: string;
  setValue: (value: string) => void;
  width?: string | number;
  height?: string | number;
  isNotValid?: boolean;
}

export const PhoneInput: React.FC<PhoneInputProps> = (props) => {
  const { name, placeholder, value, setValue, width, height, isNotValid } = props;
  const [isDisabled, setIsDisabled] = useState(false);
  const mask = ['+', '7', '(', /[0-9]/, /[0-9]/, /[0-9]/, ')', '-', /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/];

  const handlePaste = (e: any) => {
    e.preventDefault();
    let value = e.clipboardData.getData('text');
    if (value.slice(0,1) == '8') {
      value = '7' + value.slice(1, value.length);
    }
    setValue(value);
  }

  useEffect(() => {
    if (value == 'Без номера') {
      setIsDisabled(true);
    }
    else if (value?.slice(0,1) == '8') {
      setValue('7' + value.slice(1, value.length));
    }
  }, []);

  return (
    <div className='generic-phone-input'>
      {name && <div className='generic-phone-input-label'>{name}</div>}
      <div
        className='generic-phone-input__container'
        style={{
          width: width ? width : '100%',
          height: height ? height : '100%',
        }}
      >
        <InputMask
          name={name}
          className={isNotValid? 'generic-text-input__input generic-input_not-valid': 'generic-text-input__input'}
          placeholder={placeholder}
          value={value}
          onChange={(e: any) => {
            if (setValue) {
              setValue(e.target.value);
            }
          }}
          disabled={isDisabled}
          type='text'
          onPaste={handlePaste}
          pattern="(\s*)?(\+)?([- _():=+]?\d[- _():=+]?){10,14}(\s*)?"
          mask={isDisabled || value == '' || value == '+7(___)-___-__-__' ? '' : mask}
        />
        
      </div>
      
    </div>

  );
};
